'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useMemo, useState } from 'react';
import formatLang from '../helpers/format-lang';
import isBrowser from '../helpers/is-browser';
import useDebounceFunction from '../hooks/use-debounce-function';
export const LOCALE_CACHE_KEY = 'language';
export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'fr'];
export const getOtherLocale = (selectedLocale) => SUPPORTED_LANGUAGES.find((lang) => selectedLocale !== lang);
export const LocaleContext = React.createContext({
    selectedLocale: 'en',
    changeLanguage: (_locale) => { },
    localeLoading: false,
});
LocaleContext.displayName = 'LocaleContext';
const getStoredLanguage = () => {
    if (!isBrowser)
        return DEFAULT_LANGUAGE;
    const storedLanguage = localStorage.getItem(LOCALE_CACHE_KEY);
    const browserLanguage = navigator.language;
    return SUPPORTED_LANGUAGES.includes(storedLanguage)
        ? storedLanguage
        : formatLang(browserLanguage);
};
export const LocaleProvider = ({ children }) => {
    const [selectedLocale, setSelectedLocale] = useState(getStoredLanguage);
    const [loading, setLoading] = useState(false);
    const changeLanguage = useDebounceFunction((locale) => {
        if (!isBrowser)
            return;
        if (!(locale === null || locale === void 0 ? void 0 : locale.length))
            return;
        setLoading(true);
        const validLocale = formatLang(locale);
        if (validLocale !== localStorage.getItem(LOCALE_CACHE_KEY)) {
            localStorage.setItem(LOCALE_CACHE_KEY, validLocale);
        }
        setSelectedLocale(validLocale);
        setTimeout(() => setLoading(false), 200);
    }, 200);
    const contextValue = useMemo(() => ({
        selectedLocale,
        changeLanguage,
        localeLoading: loading,
    }), [changeLanguage, loading, selectedLocale]);
    return (_jsx(LocaleContext.Provider, { value: contextValue, children: children }));
};
const useLocale = () => useContext(LocaleContext);
export default useLocale;
